import { memo } from "react";
import { TransactionsContextType } from "@zenith/context/global-context/types";
import CopyToClipboard from "@zenith/components/ui/CopyToClipboard/CopyToClipboard";
import {
  shouldShow,
  isPaymentLinkCard,
  isPaymentLinkUSSD,
  isPaymentLinkQRCode,
  isPaymentLinkPayWithTransfer,
  getCardType,
  truncateText,
} from "@zenith/utils/TransactionDisplayHelpers";
import "@zenith/utils/ExtensionMethods";

export interface PaymentLinkTransactionDetailsProps {
  transaction: TransactionsContextType;
}

const PaymentLinkTransactionDetails = memo(
  function PaymentLinkTransactionDetails(
    props: PaymentLinkTransactionDetailsProps
  ) {
    const { transaction } = props;
    const paymentMethodString = transaction?.paymentMethod as string;
    
    const isCard = isPaymentLinkCard(paymentMethodString);
    const isUssd = isPaymentLinkUSSD(paymentMethodString);
    const isQrCode = isPaymentLinkQRCode(paymentMethodString);
    const isPayWithTransfer = isPaymentLinkPayWithTransfer(paymentMethodString);

    const maskedPan = transaction?.maskedPan;
    const cardType = getCardType(maskedPan);

    const showPayerDetails = isPayWithTransfer || isUssd || isCard || isQrCode;

    return (
      <>
        {showPayerDetails && shouldShow(transaction?.beneficiaryName) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Payer's Name</p>
            <p className="font-medium text-neutral-900">{transaction?.beneficiaryName}</p>
          </div>
        )}

        {showPayerDetails && shouldShow(transaction?.bankName) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Payer's Bank</p>
            <p className="font-medium text-neutral-900">{transaction?.bankName}</p>
          </div>
        )}

        {/* {showPayerDetails && shouldShow(transaction?.beneficiaryAccountNumber) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Payer's Account</p>
            <CopyToClipboard text={transaction?.beneficiaryAccountNumber} />
          </div>
        )} */}

        {isPayWithTransfer && shouldShow(transaction?.transferAccountNumber) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Merchant Account</p>
            <CopyToClipboard text={transaction?.transferAccountNumber} />
          </div>
        )}

        {(isUssd || isQrCode || isCard) && shouldShow(transaction?.sessionId) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Session ID</p>
            <CopyToClipboard text={transaction?.sessionId} />
          </div>
        )}

        {isPayWithTransfer && shouldShow(transaction?.transferAccountNumber) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Transfer Account</p>
            <CopyToClipboard text={transaction?.transferAccountNumber} />
          </div>
        )}

        {isUssd && shouldShow(transaction?.operationCode) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">USSD String</p>
            <p className="font-medium text-neutral-900">{transaction?.operationCode}</p>
          </div>
        )}

        {isCard && (
          <>
            <div className="mb-2 flex justify-between">
              <p className="text-neutral-600">Card Number</p>
              <p className="font-medium text-neutral-900">
                {maskedPan || "•••• •••• •••• ••••"}
              </p>
            </div>
            <div className="mb-2 flex justify-between">
              <p className="text-neutral-600">Card Type</p>
              <p className="font-medium text-neutral-900">{cardType}</p>
            </div>
          </>
        )}

        {shouldShow(transaction?.description) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Description</p>
            <div className="w-3/5 text-right">
              <p className="font-medium text-neutral-900 break-words">
                {truncateText(transaction?.description)}
              </p>
            </div>
          </div>
        )}
      </>
    );
  }
);

export default PaymentLinkTransactionDetails;